export default "__VITE_ASSET__Bc$AMzSj__"